import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-bookmark",
  templateUrl: "./med-icon-bookmark.component.html",
})
export class MedIconBookmarkComponent extends SvgMixinComponent {}
